export default {
  locale: {
    'auto': '系统',
    'en': '英语',
    'zh-hans': '中文',
  },
  home: {
    'intro': '欢迎来到uni-app演示',
    'toggle-langs': '切换语言',
  },
};
